import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-check-circle-fill',
  templateUrl: './icon-check-circle-fill.component.html',
  styleUrls: ['./icon-check-circle-fill.component.scss']
})
export class IconCheckCircleFillComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
